import React, { useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import * as R from 'ramda';
import { useDispatch, useSelector } from 'react-redux';


import { linkUserRepresentativeSelfcareJwt} from '../../../actions/referent-api';
import * as Loadings from '../../../constants/loadings/referent';
import { LoadingState } from '../../../_common/loadingState';


export const LinkReferent = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const referentState = useSelector(state => state.referent);
    const queryParamsToken = new URLSearchParams(location.search).get("token");

    useEffect(() => {
        if (!R.isNil(queryParamsToken)) {
            dispatch(linkUserRepresentativeSelfcareJwt(queryParamsToken))
            .then(() => window.location='/facilita')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      },[]);

    // if(R.isNil(referent)){
    //     return "";
    // }

    if(!R.isNil(referentState)){
        //SHOW A LOADING
        if (referentState.isLoading.includes(Loadings.LINKING_USERREPRESENTATIVE)) {
            return (
                <article className="flex-column mb-auto h-100 scroll-default bg-common rounded">
                    <LoadingState />
                </article>
            );
        }
        return "";
    }
    return "";
}